// @ts-nocheck
/**
 * @deprecated
 * Use the "Layout/SideColumnLayout" widget instead.
 */

import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import constants from "@store/constants";
import SideColumnLayout from "@store/Library/Components/Toolkit/Layout/SideColumnLayout";
import React, { FC } from "react";

/* Store Custom Code - Start */
const enum fields {
    showSideColumnOnMobile = "showSideColumnOnMobile",
}

export interface AccountLayoutProps extends WidgetProps {
    fields: {
        [fields.showSideColumnOnMobile]?: boolean;
    };
}

const AccountLayout: FC<AccountLayoutProps> = ({ id, fields: { showSideColumnOnMobile } }) => {
    return <SideColumnLayout id={id} showSideColumnOnMobile={showSideColumnOnMobile} />;
};
/* Store Custom Code - End */

const widgetModule: WidgetModule = {
    component: AccountLayout,
    definition: {
        group: constants.widgetGroup.layout,
        displayName: "Account Layout",
        icon: "table-layout",
        allowedContexts: [],
        /* Store Custom Code - Start */
        fieldDefinitions: [
            {
                name: fields.showSideColumnOnMobile,
                displayName: "Show side column content on mobile",
                editorTemplate: "CheckboxField",
                fieldType: "Contextual",
                defaultValue: false,
            },
        ],
        /* Store Custom Code - End */
    },
};

export default widgetModule;
